import type {
  Channel,
  Coverage,
  PolicyHolder,
  Quote,
  WebShopPublicUser,
} from "@/api_client";

import { quoteIndicatesUserMoving } from "../utils/quoteIndicatesUserMoving";
import customer from "./data/customer";
import insuranceInfo from "./data/insuranceInfo";
import objectInfo from "./data/objectInfo";
import processInfo from "./data/processInfo";
import productInfo from "./data/productInfo";
import type { PriceCalculated } from "./types/types";

export const createPriceCalculation = (
  contextId: string,
  product: Quote,
  enigmatizePolicyHolder: PolicyHolder | undefined,
  enigmatizedProduct: Quote | undefined,
  channel: Channel,
  user: WebShopPublicUser | undefined,
  coverageContent: Record<string, Coverage> | undefined,
): PriceCalculated | undefined => {
  const moving = quoteIndicatesUserMoving([product]);
  const event: PriceCalculated = {
    event: "Price Calculation",
    productInfo: productInfo.getProductInfo(product, channel),
    processInfo: processInfo.getProcessInfo("price"),
    objectInfo: [
      objectInfo.getObjectInfo(
        enigmatizePolicyHolder,
        product,
        enigmatizedProduct,
      ),
    ],
    customerInfo: customer.getCustomerInfo(
      enigmatizePolicyHolder,
      user,
      moving,
    ),
    insuranceInfo: [
      insuranceInfo.getInsuranceInfo(contextId, product, coverageContent),
    ],
  };
  return event;
};
